<template>
  <div class="login-page">
    <div class="login">
      <!-- 顶部品牌区（参考 PC 左上） -->
      <div class="lg-brand">
        <div class="lg-heart">
          <svg viewBox="0 0 24 24" fill="none" stroke="#12b3a8" stroke-width="2" stroke-linecap="round"
               stroke-linejoin="round">
            <path d="M12 21s-7-4.4-7-9.5A4.5 4.5 0 0 1 12 7a4.5 4.5 0 0 1 7 4.5C19 16.6 12 21 12 21z"/>
            <path d="M8 12h2l1-2 1.5 3 1-1h2.5"/>
          </svg>
        </div>
        <h2>益体康</h2>
        <p>欢迎登录 · 心贴智慧工作台</p>
      </div>

      <!-- 白色表单卡片（参考 PC 左侧） -->
      <div class="lg-card">
        <div class="fld" :class="{ err: accErr }">
          <label><i class="lbl-ico ico-user"></i> 账号</label>
          <div class="in">
            <input type="text" v-model="username" placeholder="手机号" autocomplete="username"/>
          </div>
          <div class="msg">{{ accErr }}</div>
        </div>
        <div class="fld" :class="{ err: pwdErr }">
          <label><i class="lbl-ico ico-lock"></i> 密码</label>
          <div class="in">
            <input :type="showPwd ? 'text' : 'password'" v-model="password" placeholder="请输入登录密码"
                   @keyup.enter="submit" autocomplete="current-password"/>
            <i class="eye" :class="{ on: showPwd }" @click="showPwd = !showPwd">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                <path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12z"/>
                <circle cx="12" cy="12" r="2.6"/>
              </svg>
            </i>
          </div>
          <div class="msg">{{ pwdErr }}</div>
        </div>

        <div class="lg-row">
          <div class="ckb" :class="{ on: remember }" @click="remember = !remember"><i></i>记住账号和密码</div>
        </div>

        <button class="btn primary block lg-btn" :disabled="loading" @click="submit">{{
            loading ? '登录中...' : '登录'
          }}
        </button>

        <div class="lg-links">
          登录即代表同意
          <a @click="goAgreement('user')">用户协议</a> 和
          <a @click="goAgreement('privacy')">隐私政策</a>
        </div>
        <div class="lg-ver">版本号 V2.8.2</div>
      </div>

    </div>
    <div class="lg-toast" :class="{ on: toastOn }">{{ toastMsg }}</div>
  </div>
</template>

<script>
import mobileRem from '@/commonJs/mobileRem';
import ApiService from '@/service/ApiService';
import pub from '@/service/public';
import cookie from '@/service/cookie';
import md5 from 'js-md5';

export default {
  name: 'MLogin',
  mixins: [mobileRem],
  data() {
    return {
      username: '',
      password: '',
      showPwd: false,
      remember: false,
      accErr: '',
      pwdErr: '',
      loading: false,
      toastOn: false,
      toastMsg: '',
      toastTimer: null
    }
  },
  created() {
    let checked = cookie.getCookie('28project_userChecked');

    if (checked == 'true') {
      let name = cookie.getCookie("28project_username");
      let pwd = cookie.getCookie("28project_userpwd");
      this.username = name;
      this.password = pwd;
      this.remember = true;
    }
  },
  methods: {
    submit() {
      this.accErr = ''
      this.pwdErr = ''
      const uname = (this.username || '').trim()
      if (!uname) {
        this.accErr = '请输入账号'
        return
      }
      if (!this.password) {
        this.pwdErr = '请输入密码'
        return
      }
      this.loading = true

      // 与 PC 端 Login.vue 传参一致，仅 agent 改为 mobile
      const params = {
        page: { number: 0, limit: 1 },
        keyWord: [],
        parms: {
          strUsrName: uname,
          strUsrPwd: md5(this.password),
          strClientUuid: 'A0F9GQHU6YE3D5AG'
        }
      }

      ApiService.UsrLogin(params, 'mobile')
        .then(res => {
          if (res && res.code === pub.backCode.SUCCESS) {
            this.handleLoginSuccess(res)
          } else {
            this.handleLoginFail(res)
          }
        })
        .catch(error => {
          console.error('登录错误：', error)
          this.pwdErr = '登录失败，请检查网络连接'
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleLoginSuccess(res) {
      
      const userInfo = (res && res.dic) || {}
      // 登录态以 localStorage 为权威源、cookie 作镜像（saveLoginState 双写 localStorage + cookie）
      pub.saveLoginState(userInfo.strAuthorization, userInfo.strRefreshToken)
      cookie.setCookie('28project_username', this.username.trim())
      cookie.setCookie('28project_UsrInfo', JSON.stringify(userInfo))

      // 记住密码：与 PC 端一致（明文存 cookie）
      if (this.remember) {
        cookie.setCookie('28project_userpwd', this.password)
        cookie.setCookie('28project_userChecked', 'true')
      } else {
        cookie.removeCookie('28project_userpwd')
        cookie.removeCookie('28project_userChecked')
      }

      // 加载系统枚举常量（同 PC 端 key，供 mobile 端订单/项目状态映射使用）
      this.loadSystemConst()
    },
    handleLoginFail(res) {
      const msg = (res && (res.message || res.msg)) || '账号或密码不正确'
      this.pwdErr = msg
    },
    loadSystemConst() {
      ApiService.GetConst({
        page: { number: 0, limit: 500 },
        keyWord: [],
        parms: {}
      }, 'mobile').then(res => {
        if (res && res.code === pub.backCode.SUCCESS) {
          cookie.setCookie('28Project_Const', JSON.stringify(res.data))
        } else {
          console.warn('获取系统枚举常量失败:', (res && (res.message || res.msg)) || '未知错误')
        }
        // 即使枚举获取失败也允许进入首页（页面会兜底）
        this.$router.replace('/m/home')
      }).catch(error => {
        console.error('获取枚举常量错误：', error)
        this.$router.replace('/m/home')
      })
    },
    showToast(msg) {
      this.toastMsg = msg
      this.toastOn = true
      clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => {
        this.toastOn = false
      }, 1800)
    },
    goAgreement(type) {
      this.$router.push('/m/agreement?type=' + type)
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent
}

.login-page {
  --primary: #12b3a8;
  --primary-d: #0d9b91;
  --primary-l: #e8f8f6;
  --danger: #f5544b;
  --danger-l: #ffeeed;
  --t1: #14181f;
  --t2: #5b6472;
  --t3: #9aa4b2;
  --line: #eef0f4;
  --bg: #f4f6f8;
  --card: #fff;
  font-size: 14px;
  line-height: normal;
  -webkit-text-size-adjust: 100%;
  min-height: 100vh;
  background: var(--bg);
  display: flex;
  flex-direction: column
}

button {
  cursor: pointer
}

.login {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  background: var(--bg)
}

/* 品牌区 */
.lg-brand {
  flex: none;
  text-align: center;
  padding: 52px 24px 22px
}

.lg-heart {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: var(--primary-l);
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center
}

.lg-heart svg {
  width: 28px;
  height: 28px
}

.lg-brand h2 {
  font-size: 23px;
  font-weight: 800;
  color: var(--t1);
  letter-spacing: 2px
}

.lg-brand p {
  font-size: 13px;
  color: var(--t3);
  margin-top: 5px
}

/* 白色表单卡片 */
.lg-card {
  margin: 0 20px;
  background: #fff;
  border-radius: 18px;
  padding: 26px 22px 20px;
  box-shadow: 0 10px 32px rgba(20, 24, 31, .08)
}

.fld {
  margin-bottom: 15px
}

.fld label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: var(--t2);
  margin-bottom: 7px;
  font-weight: 500
}

.lbl-ico {
  width: 15px;
  height: 15px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  opacity: .55
}

.lbl-ico.ico-user {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%235b6472' stroke-width='2'><circle cx='12' cy='8' r='4'/><path d='M4 21c0-4 4-7 8-7s8 3 8 7'/></svg>")
}

.lbl-ico.ico-lock {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%235b6472' stroke-width='2'><rect x='5' y='11' width='14' height='10' rx='2'/><path d='M8 11V7a4 4 0 1 1 8 0v4'/></svg>")
}

.fld .in {
  position: relative;
  display: flex;
  align-items: center
}

.fld input {
  flex: 1;
  width: 100%;
  height: 46px;
  background: var(--bg);
  border-radius: 11px;
  padding: 0 13px;
  font-size: 15px;
  color: var(--t1);
  border: 1.5px solid transparent;
  transition: .15s
}

.fld input:focus {
  border-color: var(--primary);
  background: #fff;
  box-shadow: 0 0 0 3px var(--primary-l)
}

.fld.err input {
  border-color: var(--danger);
  background: var(--danger-l)
}

.fld .msg {
  font-size: 12px;
  color: var(--danger);
  margin-top: 5px;
  display: none
}

.fld.err .msg {
  display: block
}

.fld .eye {
  position: absolute;
  right: 2px;
  height: 46px;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--t3)
}

.fld .eye svg {
  width: 18px;
  height: 18px
}

.lg-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12.5px;
  color: var(--t2);
  margin: 2px 0 20px
}

.ckb {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer
}

.ckb i {
  width: 15px;
  height: 15px;
  border-radius: 4px;
  border: 1.5px solid #cfd5de;
  display: flex;
  align-items: center;
  justify-content: center
}

.ckb.on i {
  background: var(--primary);
  border-color: var(--primary)
}

.ckb.on i::after {
  content: "";
  width: 4px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) translate(-1px, -1px)
}

.lg-btn {
  height: 48px;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 700;
  background: linear-gradient(135deg, #12b3a8, #0b948c);
  box-shadow: 0 6px 18px rgba(18, 179, 168, .30);
  margin-top: 4px;
  transition: .15s
}

.lg-btn:active {
  transform: scale(.97);
  box-shadow: 0 3px 10px rgba(18, 179, 168, .25)
}

.lg-links {
  text-align: center;
  font-size: 11.5px;
  color: var(--t3);
  margin-top: 14px;
  line-height: 1.8
}

.lg-links a {
  color: var(--primary);
  text-decoration: none;
  cursor: pointer
}

.lg-ver {
  text-align: center;
  font-size: 11px;
  color: #c8ced8;
  margin-top: 10px;
  padding-bottom: 2px
}

.lg-tip {
  text-align: center;
  font-size: 12px;
  color: var(--t3);
  padding: 14px 20px calc(14px + env(safe-area-inset-bottom))
}

.lg-tip b {
  color: var(--primary);
  font-weight: 600
}

/* 通用按钮（登录按钮复用） */
.btn {
  height: 31px;
  padding: 0 15px;
  border-radius: 16px;
  font-size: 13px;
  border: 1px solid #dfe3ea;
  color: var(--t2);
  background: #fff;
  transition: .12s
}

.btn:active {
  transform: scale(.96)
}

.btn.primary {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
  font-weight: 600
}

.btn.block {
  width: 100%;
  height: 46px;
  border-radius: 23px;
  font-size: 16px;
  border: none
}

.btn:disabled {
  opacity: .6
}

/* 登录成功 Toast（对齐原型暗色胶囊） */
.lg-toast {
  position: fixed;
  left: 50%;
  top: 44%;
  transform: translate(-50%, -50%) scale(.9);
  background: rgba(20, 24, 31, .88);
  color: #fff;
  padding: 11px 18px;
  border-radius: 9px;
  font-size: 13.5px;
  z-index: 90;
  opacity: 0;
  visibility: hidden;
  transition: .2s;
  max-width: 72%;
  text-align: center;
  line-height: 1.5
}

.lg-toast.on {
  opacity: 1;
  visibility: visible;
  transform: translate(-50%, -50%) scale(1)
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/MLogin.vue